(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["expandable-grid"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.expandable-grid').forEach(function (grid) {
    var initialVisible = parseInt(grid.dataset.initialVisible, 10);
    var items = Array.from(grid.querySelectorAll('.expandable-grid__items > *'));
    var itemsEl = grid.querySelector('.expandable-grid__items');
    var toggle = grid.querySelector('.expandable-grid__toggle');
    var label = grid.querySelector('.expandable-grid__toggle-label');

    if (!toggle) return;

    if (items.length <= initialVisible) {
      toggle.closest('.expandable-grid__footer').style.display = 'none';
      return;
    }

    var extraItems = items.slice(initialVisible);

    extraItems.forEach(function (item) {
      item.setAttribute('hidden', '');
    });

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      var nowExpanded = !expanded;

      toggle.setAttribute('aria-expanded', String(nowExpanded));
      label.textContent = nowExpanded ? toggle.dataset.hideLabel : toggle.dataset.showLabel;

      if (nowExpanded) {
        // Lock current height before adding items to layout
        var fromHeight = itemsEl.offsetHeight;
        extraItems.forEach(function (item) {
          item.removeAttribute('hidden');
          item.style.opacity = '0';
          item.style.transform = 'translateY(8px)';
        });
        var toHeight = itemsEl.scrollHeight;
        itemsEl.style.height = fromHeight + 'px';

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            itemsEl.style.height = toHeight + 'px';
            extraItems.forEach(function (item, i) {
              item.style.transition = 'opacity 0.3s ease ' + (i * 25) + 'ms, transform 0.3s ease ' + (i * 25) + 'ms';
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            });
          });
        });

        itemsEl.addEventListener('transitionend', function handler(e) {
          if (e.target !== itemsEl) return;
          itemsEl.style.height = '';
          extraItems.forEach(function (item) {
            item.style.transition = '';
            item.style.opacity = '';
            item.style.transform = '';
          });
          itemsEl.removeEventListener('transitionend', handler);
        });

      } else {
        // Fade out items, then collapse height
        var fadeDuration = 200 + (extraItems.length - 1) * 20;
        extraItems.forEach(function (item, i) {
          item.style.transition = 'opacity 0.2s ease ' + (i * 20) + 'ms, transform 0.2s ease ' + (i * 20) + 'ms';
          item.style.opacity = '0';
          item.style.transform = 'translateY(4px)';
        });

        setTimeout(function () {
          var fromHeight = itemsEl.offsetHeight;

          extraItems.forEach(function (item) {
            item.setAttribute('hidden', '');
            item.style.transition = '';
            item.style.opacity = '';
            item.style.transform = '';
          });

          var toHeight = itemsEl.scrollHeight;
          itemsEl.style.height = fromHeight + 'px';

          requestAnimationFrame(function () {
            itemsEl.style.height = toHeight + 'px';
          });

          itemsEl.addEventListener('transitionend', function handler(e) {
            if (e.target !== itemsEl) return;
            itemsEl.style.height = '';
            itemsEl.removeEventListener('transitionend', handler);
          });
        }, fadeDuration);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
